import React from "react";
import cloud_mgmt_banner from "../../assets/cloud_mgmt/cloud_mgmt_banner.png";
import { TypeAnimation } from "react-type-animation";
import MovingText from "react-moving-text";
import Button from "@mui/material/Button";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CloudMgmtBanner = () => {
  const theme = useTheme();
    const navigate = useNavigate();

  return (
    <div>
      {/* <div className="flex flex-col-reverse sm:flex-row py-10 sm:py-20 px-2 sm:px-5 bg-gradient-to-r to-fuchsia-400 from-amber-400">
        <div className="relative">
          <div className="w-full text-xl sm:text-5xl px-2 sm:px-10 font-bold font-notosans"> */}
      <div className="flex flex-col sm:flex-row justify-center w-full relative bg-gradient-to-r to-fuchsia-400 from-amber-400">
        <div className="w-full sm:w-1/2 md:top-1 lg:top-24 py-10 flex flex-col justify-center">
          <div className="w-full text-lg sm:text-4xl px-10 font-bold poppins-bold text-[#333e49] text-center">
            <MovingText
              type="fadeInFromBottom"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              Efficient Cloud Management Solutions for Seamless Operations
            </MovingText>
          </div>
          <div className="w-full text-sm sm:text-lg  px-10 sm:leading-[5.5rem] font-notosans text-center text-[#ff5e16] font-semibold leading-5">
            {/* Crafting Innovative Websites Tailored to Your Vision */}

            <MovingText
              type="fadeInFromLeft"
              duration="1000ms"
              delay="0s"
              direction="normal"
              timing="ease"
              iteration="1"
              fillMode="none"
            >
              <TypeAnimation
                sequence={[
                  'We Experts in "Managed Cloud Service"',
                  1000,
                  'We Experts in "Cloud Computing"',
                  1000,
                  'We Experts in "Cybersecurity"',
                  1000,
                ]}
                wrapper="span"
                speed={50}
                style={{ fontSize: "1em", display: "inline-block" }}
                repeat={Infinity}
              />
            </MovingText>
          </div>
          <p className="px-2 sm:px-10 text-center mt-3">
            <Button
              size={
                useMediaQuery(theme.breakpoints.down("sm")) ? "small" : "medium"
              }
              variant="contained"
              onClick={() => navigate("/contact")}
            >
              Free Consultation
            </Button>
          </p>
        </div>
        <div className="w-full sm:w-1/2 flex justify-center">
          <img
            src={cloud_mgmt_banner}
            className="w-[15rem] sm:w-[30rem] animate-pulse"
          />
        </div>
      </div>
    </div>
  );
};

export default CloudMgmtBanner;
